import { updateTokensWithOrderToken } from '../../tokens';
import { ORDER_TOKEN_HEADER } from '../../../api/base';

export const handleUpdateOrderToken = (dispatch, headers) =>
    dispatch(updateTokensWithOrderToken(headers.get(ORDER_TOKEN_HEADER)));
